import styled from 'styled-components';

export const Pages = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DeviceTypeWrapper = styled.div`
  margin-bottom: 24px;
  background: ${({ theme }) => theme.colors.background};

  .ant-radio-group {
    .ant-radio-button-wrapper {
      background: transparent;
      color: ${({ theme }) => theme.colors.text1};
      transition: 0.3s;
      font-size: 0.8rem;
    }

    .ant-radio-button-wrapper-checked {
      opacity: 1;
      color: var(--primary-color);
    }
  }
`;

export const PagesMenuContainer = styled.div<{ onlyOneCategory?: boolean }>`
  height: 100%;
  .root-cannot-see-page {
    opacity: 0.3;
  }

  .ant-menu-item-group-title {
    font-size: ${({ theme }) => theme.fontSizes.verySmall};
    text-transform: uppercase;
    font-weight: bold;
    margin-bottom: 8px;
    color: ${({ theme }) => theme.colors.text2};
  }

  .ant-menu-item-group:nth-child(n + 2) {
    margin-top: 16px;
  }

  .ant-menu {
    background: transparent !important;

    .ant-menu-title-content {
      white-space: normal;
      height: auto;
      line-height: 1rem;
      font-size: ${({ theme }) => theme.fontSizes.small};
      color: ${({ theme }) => theme.colors.text1};
    }
  }

  .ant-menu-item {
    padding: -10px !important;
    margin-bottom: 0 !important;
    height: 36px;

    svg {
      color: ${({ theme }) => theme.colors.text1};
    }
    .custom-alert-warning {
      svg {
        color: ${({ theme }) => theme.colors.yellow} !important;
      }
    }
  }

  .ant-menu-item-selected {
    font-weight: bold;

    svg {
      color: ${({ theme }) => theme.colors.white};
    }
    .custom-alert-warning {
      svg {
        color: ${({ theme }) => theme.colors.yellow} !important;
      }
    }
  }

  .ant-menu-item-group-title {
    border-radius: 4px;
  }

  .ant-menu-item {
    border-radius: 4px;
    transition: 0.2s;
    padding-left: 16px !important;
    font-size: 0.8rem;

    .ant-menu-item-icon {
      margin-left: 8px;
    }

    :hover {
      background: ${({ theme }) => theme.colors.background1};
    }
  }

  li > div {
    background: ${({ theme }) => theme.colors.background1};
  }
`;
